import type { ShowcaseTab } from "@/components/feed-header";
import type { LibraryKind } from "@/lib/mock/library";

// "alerts" is a virtual tab: it shows Signals + Automations together (the two
// things a user can subscribe to). It is not a LibraryKind.
export type LibraryTab = LibraryKind | "all" | "alerts";

const VALID_LIBRARY_TABS: LibraryTab[] = [
  "all",
  "alerts",
  "skill",
  "signal",
  "automation",
  "idea",
  "video",
];

/** Parse ?tab= from the library URL; invalid/missing values fall back to "all". */
export function parseLibraryTab(raw: string | null): LibraryTab {
  if (raw && VALID_LIBRARY_TABS.includes(raw as LibraryTab)) {
    return raw as LibraryTab;
  }
  return "all";
}

const SHOWCASE_TO_LIBRARY_TAB: Partial<Record<ShowcaseTab, LibraryKind>> = {
  skills: "skill",
  signals: "signal",
  automations: "automation",
  curated: "idea",
  watch: "video",
};

/** Home showcase "Browse more" → library with the matching filter pre-selected. */
export function buildLibraryBrowseMoreHref(activeTab: ShowcaseTab): string {
  const libraryTab = SHOWCASE_TO_LIBRARY_TAB[activeTab];
  if (!libraryTab) return "/library";
  return `/library?tab=${libraryTab}`;
}
